import { z } from 'zod';
import { BuildJobStatusSchema, BuildTypeSchema } from './types.schema.js';

// Internal Build Status Update API (called by build job to update service)
export const UpdateBuildStatusRequestSchema = z.object({
  userId: z.string().min(1, 'User ID is required'),
  buildId: z.string().min(1, 'Build ID is required'),
  projectId: z.string().min(1, 'Project ID is required'),
  buildType: BuildTypeSchema,
  status: BuildJobStatusSchema,
  errorMessage: z.string().optional(),
});

export type UpdateBuildStatusRequest = z.infer<typeof UpdateBuildStatusRequestSchema>;
